<form [formGroup]="agregarFormCondCliente">
  <input name="id_cliente_ant" formControlName="id_cliente_ant" type="hidden" />
  <div class="row align-items-center">
    <div class="col-lg-12">
      <app-lfsa-input [control]="this.agregarFormCondCliente.get('id_promo')" [id]="'id_promo'"
        [isReadOnly]="true" [label]="'ID PROMO'" formControlName="id_promo" type="text"></app-lfsa-input>
    </div>
    <div class="form-group col-md-4">
      <span class="d-block">{{clienteTitle|titlecase}}</span>
      <button class="btn btn-primary col" role="button" data-bs-toggle="modal" data-bs-target="#clienteModal">
        <span>Buscar Cliente</span>
        <i class="fas fa-search"></i>
      </button>
    </div>
    <div class="col-lg-6">
      <app-lfsa-input [control]="this.agregarFormCondCliente.get('cantidad_maxima')" [id]="'cantidad_maxima'"
        [isReadOnly]="false" [label]="'Cantidad Máxima'" formControlName="cantidad_maxima"
        type="number"></app-lfsa-input>
    </div>
    <div class="col-lg-6">
      <app-lfsa-input [control]="this.agregarFormCondCliente.get('control_maximo')" [id]="'control_maximo'"
        [isReadOnly]="false" [label]="'Control Máximo'" formControlName="control_maximo"
        type="number"></app-lfsa-input>
    </div>
    <div class="col-lg-12">
      <app-lfsa-input [control]="this.agregarFormCondCliente.get('numero_maximo_compras')"
        [id]="'numero_maximo_compras'" [isReadOnly]="false" [label]="'Num. máximo compras'"
        formControlName="numero_maximo_compras" type="number"></app-lfsa-input>
    </div>
  </div>
  <app-lfsa-botones-formulario (devolverAccion)="accionesCondCliente($event)"
    [formularioValido]="(!agregarFormCondCliente.invalid) ? false : true"
    [textBoton]="'Guardar'" class="row">
  </app-lfsa-botones-formulario>
</form>
